// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  BorderOutlined,
  BoxPlotOutlined,
  ChromeOutlined,
  DashboardOutlined,
  DeploymentUnitOutlined,
  GatewayOutlined,
  MenuUnfoldOutlined,
  QuestionOutlined,
  HeartOutlined,
  RocketOutlined,
  PhoneOutlined,
  FireOutlined,
  TagOutlined,
  UserOutlined,
  EditOutlined,
} from "@ant-design/icons";

// icons
const icons = {
  ChromeOutlined,
  MenuUnfoldOutlined,
  BoxPlotOutlined,
  RocketOutlined,
  FireOutlined,
  BorderOutlined,
  HeartOutlined,
  GatewayOutlined,
  QuestionOutlined,
  DeploymentUnitOutlined,
  DashboardOutlined,
  TagOutlined,
  UserOutlined,
  EditOutlined,
  PhoneOutlined,
};

const main = {
  id: "main",
  title: <FormattedMessage id="Main" />,
  type: "group",
  children: [
    {
      id: "dashboard",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",
      url: "/",
      icon: icons.DashboardOutlined,
    },
    {
      id: "orders",
      title: <FormattedMessage id="Orders" />,
      type: "item",
      url: "/orders",
      icon: icons.HeartOutlined,
    },
    {
      id: "sales",
      title: <FormattedMessage id="Sales" />,
      type: "item",
      url: "/sales",
      icon: icons.TagOutlined,
    },
    {
      id: "lists",
      title: <FormattedMessage id="Lists" />,
      type: "item",
      url: "/lists",
      icon: icons.PhoneOutlined,
    },
    {
      id: "profile",
      title: <FormattedMessage id="Profile" />,
      type: "item",
      url: "/profile",
      icon: icons.UserOutlined,
    },
  ],
};

export default main;
